export const createJudgesRequests = (client) => ({
    listJudges: async (params) => {
        const { data, meta, links } = await client.api.get("judges", {
            params: params,
        });
        return { data, meta, links };
    },
});
//# sourceMappingURL=index.js.map